import React from 'react';
import styled from 'styled-components';

import ResponsiveTileView from '../components/responsiveTileView';
import Section from '../components/section';
import { Overview, Title } from '../components/text';
import theme from '../styles/theme';

const LightOverview = styled(Overview)`
  && {
    color: ${props => props.theme.color.white};
  }
`;

export default () => {
  return (
    <Section background={theme.color.sharePointTeal}>
      <Title isLight>Design great web parts</Title>
      <LightOverview>
        The SharePoint design system leverages the power of Fluent UI and
        the SharePoint Framework to make it easy to get started quickly in
        creating your next web part.
      </LightOverview>
      <ResponsiveTileView
        tiles={[
          {
            title: 'Web part basics',
            description:
              'Leverage the basic building blocks of a modern web part to work great on any page.',
            linkText: 'Get guidance',
            linkTarget:
              'https://docs.microsoft.com/en-us/sharepoint/dev/design/design-a-web-part',
            rowSpan: '2',
          },
          {
            title: 'Theme a web part',
            description:
              'Learn how to build a web part to adjust for various site themes.',
            linkText: 'Get guidance',
            linkTarget:
              'https://docs.microsoft.com/en-us/sharepoint/dev/design/themes-colors',
          },
          {
            title: 'Responsive design',
            description:
              'Optimize your web part to reflow to fit and page layout and screen size.',
            linkText: 'Get guidance',
            linkTarget:
              'https://docs.microsoft.com/en-us/sharepoint/dev/design/reactive-and-nonreactive-web-parts',
          },
          {
            title: 'Commanding',
            description:
              'Consistency in actions and navigation across web parts is essential in making them easy to use.',
            linkText: 'Learn about commanding',
            linkTarget:
              'https://docs.microsoft.com/en-us/sharepoint/dev/design/web-part-commanding',
          },
          {
            title: 'Accessibility',
            description: `Design an experience that meets all users' unique visual, hearing, dexterity, cognitive and speech needs.`,
            linkText: 'See our accessibility guidance',
            linkTarget:
              'https://docs.microsoft.com/en-us/sharepoint/dev/design/accessibility',
          },
          {
            title: 'Titles and descriptions',
            description:
              'Follow patterns to make your web part customizable for users unique content.',
            linkText: 'See our patterns',
            linkTarget:
              'https://docs.microsoft.com/en-us/sharepoint/dev/design/web-part-titles-and-descriptions',
          },
          {
            title: 'Layouts',
            description:
              'Leverage a variety of web part layouts to make your web part reflow across columns.',
            linkText: 'See our layout guidelines',
            linkTarget:
              'https://docs.microsoft.com/en-us/sharepoint/dev/design/layout-patterns',
          },
          {
            title: 'Examples',
            description:
              'Here are a few example web parts to get you started designing a web part.',
            linkText: 'Show me',
            linkTarget:
              'https://docs.microsoft.com/en-us/sharepoint/dev/design/key-web-part-examples',
          },
        ]}
        gridRowsMedium={5}
        gridRowsLarge={3}
      />
    </Section>
  );
};



// WEBPACK FOOTER //
// ./src/sections/webParts.js